<footer>
  <div class="footer-wrapper">
    <div class="container-footer">
      <div class="footer-main">
        <div class="logo">
          <img src="/assets/img/logo-Ubilaw-footer.svg" alt="UBILAW" />
        </div>
        <app-secondary-nav></app-secondary-nav>
      </div>
      <div class="copy">Tous droits réservés &copy; UBILAW | 2023</div>
    </div>
  </div>
</footer>
